// @flow
import React, { useEffect, useRef, useState } from "react";
import { Btn } from "../../styles/Button.styled";

import { Container } from "../../styles/Sidebar/UploadModal.styled";
import Popup from "../Popup/Popup";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  attributesDocEdit,
  getAttributes,
  attributesDocsEdit,
} from "../../actions/attributes";
import { AttributeFactory } from "./AttributeInputs";
import { AttributeItem } from "./interfacesAttr";
import { getTypes } from "../../actions/types";
import styles from "../../styles/Attr.module.css";

export function AddAttributesDocPopup({
  handleClose,
  singleAttr,
  selectedDocs,
  hint,
  ...doc
}: {
  handleClose: () => void;
  singleAttr?: string;
  selectedDocs?: string[];
  hint?: string;
  [key: string]: any;
}) {
  const [activeAttr, setActiveAttr] = useState<string>("");
  const [mainData, setMainData] = useState<Record<string, any>>({});
  const initialAttrRef = useRef<Record<string, any>>({});
  const [addAttr, setAddAttr] = useState<Record<string, AttributeItem>>({});

  const dispatch = useAppDispatch();
  const attributesCommon = useAppSelector((state) => state.attributes);
  const docType = useAppSelector((state) => state.types);

  const closePopup = () => {
    handleClose();
  };

  useEffect(() => {
    if (attributesCommon.state === "idle") {
      dispatch(getAttributes(null));
    }
  }, [dispatch]);

  useEffect(() => {
    if (docType.state === "idle") {
      dispatch(getTypes());
    }
  }, [dispatch, docType]);

  const fields = [
    {
      title: "Тип документу",
      value: doc.type?.title,
      type: { id: "1",alias: "radio" },
      id: "type",
      data: docType.list,
    },

    {
      title: "Назва документу",
      value: doc.title,
      type: { id: "2",alias: "string" },
      id: "title",
      data: null,
    },
    {
      title: "Номер документу",
      value: doc.number,
      type: { id: "3",alias: "string" },
      id: "number",
      data: null,
    },
    {
      title: "Дата документу",
      value: doc.date,
      type: { id: "4", title: "Дата", alias: "date" },
      data: null,
      id: "date",
    },

    {
      title: "Сума",
      value: doc.amount,
      type: { id: "5",alias: "money" },
      data: null,
      id: "amount",
    },
        {
      title: "Коментар",
      value: doc.comment,
      type: { id: "6",alias: "textarea" },
      data: null,
      id: "comment",
    },

  ];

  // Number(selected)

  // const getChangedAttributes = (attributesCommon: any) => {
  //   const { list, initialList } = attributesCommon;

  //   if (!list || !initialList) return [];

  //   return list
  //     .filter((currentItem: any) => {
  //       const initialItem = initialList.find(
  //         (i: any) => i.id === currentItem.id,
  //       );
  //       return currentItem.selected !== initialItem?.selected;
  //     })
  //     .map((changedItem: any) => ({
  //       id: changedItem.id,
  //       value: changedItem.selected,
  //     }));
  // };

  const activeSave =
    Object.keys(addAttr).length > 0 || Object.keys(mainData).length > 0;
  // console.log(
  //   Object.keys(addAttr).length === 0,
  //   Object.keys(mainData).length === 0,
  //   activeSave,
  // );
  // const displayList = (() => {

  //   if (singleAttr) {
  //     return attributesCommon.list.filter(
  //       (attr: any) => attr.id === singleAttr,
  //     );
  //   }
  //   const list = Array.isArray(attributesCommon?.list) ? attributesCommon.list : [];
  //   return [...fields, ...list];

  // })();

  const displayList = (() => {
    const baseList = Array.isArray(attributesCommon?.list)
      ? attributesCommon.list
      : [];

    const docList = Array.isArray(doc?.attributes) ? doc.attributes : [];

    let combined: any[] = [];

    if (singleAttr) {
      combined = baseList.filter((attr: any) => attr.id === singleAttr);
    } else {
      combined = [...fields, ...docList];
    }
    return combined.sort((a, b) => {
      const titleA = a.title || "";
      const titleB = b.title || "";
      return titleA.localeCompare(titleB);
    });
  })();
  const changedAttrs = Object.values(addAttr).filter(
    (attr: any) => initialAttrRef.current[attr.id]?.value !== attr.value,
  );

  const handleUpdate = (id: string, newValue: any, alias: string) => {
    const processedValue = alias === "number" ? Number(newValue) : newValue;

    const fieldIds = new Set(fields.map((f) => f.id));
    if (fieldIds.has(id)) {
      const currentItem = fields.find((el) => el.id === id);

      setMainData((prev) => ({
        ...prev,
        [id]: {
          ...currentItem,
          value: processedValue,
        },
      }));
    } else {
      setAddAttr((prev) => {
        const currentItem = prev[id] || displayList.find((el) => el.id === id);
        if (!currentItem) return prev;
        return {
          ...prev,
          [id]: {
            ...currentItem,
            value: processedValue,
          },
        };
      });
    }
  };

  const hasValue = (v: any) => v !== null && v !== undefined && v !== "";

  const handleSave = () => {
    const regularAttrs = (Object.values(addAttr) as any[]).filter((attr) =>
      hasValue(attr.value),
    );
    if (selectedDocs && selectedDocs.length > 0) {
      const editedAttributes = selectedDocs.map((docId: string) => ({
        id: docId,
        attributes: regularAttrs,
      }));
      dispatch(attributesDocsEdit(editedAttributes));
    } else {
      const hasFieldChanges = Object.keys(mainData).length > 0;
      const hasRegularChanges = regularAttrs.length > 0;

      if (hasFieldChanges) {
        const fieldData = Object.values(mainData).reduce(
          (acc: any, item: any) => {
            if (hasValue(item.value)) acc[item.id] = item.value;
            return acc;
          },
          {},
        );
        if (Object.keys(fieldData).length > 0) {
          dispatch(attributesDocEdit(fieldData, doc.id));
        }
      }
      if (hasRegularChanges && changedAttrs.length > 0) {
        const editedAttributes = { id: doc.id, attributes: regularAttrs };
        dispatch(attributesDocEdit(editedAttributes, doc.id));
      }
    }
    handleClose();
  };
  // const handleSave = () => {
  //   console.log('handleSave', addAttr)

  //   if (selectedDocs && selectedDocs.length > 0) {
  //     const attributesArray = Object.values(addAttr);
  //     const editedAttributes = selectedDocs.map((docId: string) => ({
  //       id: docId,
  //       attributes: attributesArray,
  //     }));
  //     dispatch(attributesDocsEdit(editedAttributes));
  //   } else {
  //     if (addAttr.find(filds[0].id)||) {

  //     } else {
  //       const editedAttributes = { id: doc.id, attributes: addAttr };
  //       dispatch(attributesDocEdit(editedAttributes, doc.id));

  //     }
  //   }
  //   handleClose();
  // };

  // const handleCheckMandatory = () => {
  //   const itemFromList = displayList.find((a) => a.id === activeAttr);

  //   setAddAttr((prev) => ({
  //     ...prev,
  //     [activeAttr]: {
  //       ...(prev[activeAttr] || itemFromList),
  //       mandatory: !(prev[activeAttr]?.mandatory ?? false),
  //     },
  //   }));
  // };
  useEffect(() => {
    if (doc?.attributes) {
      const data = Object.fromEntries(
        doc.attributes.map((a: any) => [a.id, a]),
      );
      setAddAttr(data);
      initialAttrRef.current = data;
    }
  }, []);

  useEffect(() => {
    if (
      attributesCommon.state === "success" &&
      displayList.length > 0 &&
      !activeAttr
    ) {
      setActiveAttr(displayList[0].id);
    }
  }, [attributesCommon.state, displayList]);

  const docList = Array.isArray(doc?.attributes) ? doc.attributes : [];
  const hasAdditionalAttrs = !singleAttr && docList.length > 0;

  return (
    <Popup
      clickCloseButton={closePopup}
      className={styles.addAttributesDocPopup_modal}
      style={{
        height: "max-content",
        maxHeight: "90dvh",
        width: "90vw",
        maxWidth: hasAdditionalAttrs ? "900px" : "480px",
        transition: "max-width 0.35s ease",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <h1
        className={styles.addAttributesDocPopup_title}
        style={{ marginBottom: hint ? 8 : 20 }}
      >
        {singleAttr
          ? "Редагування параметру"
          : doc?.attributes
            ? "Редагування атрибутів документу"
            : "Виберіть додаткові параметри для призначення документу"}
      </h1>

      {hint && (
        <div
          style={{
            fontSize: "13px",
            color: "var(--vivid-pink)",
            fontWeight: 500,
            marginBottom: 16,
          }}
        >
          {hint}
        </div>
      )}

      <Container className={styles.addAttributesDocPopup_container}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: hasAdditionalAttrs ? "1fr 1fr" : "1fr 0fr",
            transition: "grid-template-columns 0.35s ease",
            gap: hasAdditionalAttrs ? "20px" : "0",
            overflow: "hidden",
            minWidth: 0,
            maxHeight: "calc(90dvh - 160px)",
          }}
        >
          {/* Лівий стовпець — основні поля */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "22px",
              backgroundColor: "var(--background)",
              borderRadius: "12px",
              padding: "16px",
            }}
          >
            {fields.map((el) => (
              <div key={el.id}>
                <AttributeFactory
                  key={el.id}
                  item={addAttr[el.id] || mainData[el.id] || el}
                  handleUpdate={handleUpdate}
                  border={false}
                />
              </div>
            ))}
          </div>

          {/* Правий стовпець — додаткові атрибути */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              overflowY: "auto",
              maxHeight: "60vh",
              opacity: hasAdditionalAttrs ? 1 : 0,
              transform: hasAdditionalAttrs
                ? "translateX(0)"
                : "translateX(16px)",
              transition: "opacity 0.3s ease 0.1s, transform 0.3s ease 0.1s",
              minWidth: 0,
            }}
          >
            {docList.map((el: any) => (
              <div
                key={el.id}
                style={{
                  backgroundColor: "var(--white)",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "12px",
                }}
              >
                <AttributeFactory
                  key={el.id}
                  item={addAttr[el.id] || mainData[el.id] || el}
                  handleUpdate={handleUpdate}
                  border={false}
                  labelStyle={{ background: "var(--white)" }}
                />
              </div>
            ))}
          </div>
        </div>

        <div className={styles.addAttributesDocPopup_footer}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={closePopup}
            $background="var(--sidebar-hover)"
            $heightMobile="47px"
          >
            Відмінити
          </Btn>

          <Btn
            style={{ flex: 1 }}
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            onClick={handleSave}
            $background="var(--blue)"
            $heightMobile="47px"
            disabled={!activeSave}
          >
            Зберегти
          </Btn>
        </div>
      </Container>
    </Popup>
  );
}
